module.exports = __webpack_public_path__ + "static/media/population.6c14eb24.jpg";